import { defineComponent as _defineComponent } from 'vue'
import { STermsAndConditions } from '@slg/web-customer-shared';

import { getMetaInfo } from '@/utils/seo';

const __default__ = {
  name: 'TermsAndConditionsPage',
  metaInfo() {
    return getMetaInfo((this as { pageData?: { Seo?: unknown } }).pageData?.Seo);
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return { __sfc: true,STermsAndConditions }
}

})